import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum VideoType {
	Raw = 'raw',
	YouTube = 'youtube',
	Wingfield = 'wingfield',
}

export enum VideoSource {
	Link = 'link',
	Veo = 'veo',
	Wingfield = 'wingfield',
}

export interface Video extends Record, Dateable, AllowedActionable {
	private: boolean;
	userId?: number;
	accountId: number;
	groupId: number;
	thumbnailAttachmentId: number;
	uri: string;
	duration: number;
	title: string;
	description: string;
	type: VideoType;

	account?: models.account.Account;
	author?: models.author.Author;
	thumbnail?: models.attachment.Attachment;
	sequences: models.videoSequence.VideoSequence[];
	group?: models.group.Group;
	connectedGame?: models.game.GameOverview;
}

export interface VideoUpdatePayload {
	groupId?: number;
	thumbnailAttachmentId?: number;

	title?: string;
	description?: string;
	duration?: number;
}

export enum WingfieldVideoType {
	Unknown = 'unknown',
	Session = 'session',
	Highlight = 'hightlights',
}

export enum WingfieldSessionType {
	Unknown = 'unknown',
	Match = 'match',
	Freeplay = 'freeplay',
	Drill = 'drill',
}

export interface WingfieldVideoSource {
	id?: string | number; // useCollection expects an ID
	sessionId: string;
	date: number;
	durationSeconds: number;
	exipiresAt: number;
	sessionType: WingfieldSessionType;
	videoType: WingfieldVideoType;
	thumbnailUrl: string;
	videoUrl: string;
}
